<h2>{{ ('enum.task-action-type.' + taskActionTypeEnum[taskAction.type]) | translate }}</h2>

@if (taskAction.type == taskActionTypeEnum.productLaunch) {
	<product-launch-view [taskAction]="taskAction" />
}

@if (!taskAction.completed) {
	<section>
		<edit-row (valueChanged)="updateDetails($event)"
				  [model]="taskAction.details"
				  [displayValue]="taskAction.details"
				  [isHtmlContent]="true"
				  [label]="'task-action.details' | translate"
				  [inputType]="inputTypeEnum.Editor" />
		@if (taskAction.type === taskActionTypeEnum.inquiry) {
			<edit-row (valueChanged)="updateInquiryReply($event)"
					  [model]="inquiryModel.reply"
					  [displayValue]="inquiryModel.reply"
					  [label]="'task-action.inquiry-reply' | translate"
					  [inputType]="inputTypeEnum.Textarea"
					  [placeholder]="'task-action.inquiry-reply' | translate" />
		}

		<div>
			<edit-row (valueChanged)="updateTaskArea($event)"
					  [model]="taskAction.taskAreaId"
					  [displayValue]="taskAction.taskArea ? ('task-area.area-name.' + taskAction.taskArea.name | translate) : ('task-action.area-placeholder' | translate)"
					  [label]="'task-action.area' | translate"
					  [inputType]="inputTypeEnum.Select"
					  [selectList]="taskAreaList"
					  [placeholder]="'task-action.area-placeholder' | translate" />
		</div>
		<div>
			<edit-row (valueChanged)="updatePlannedDate($event)"
					  [model]="taskPlanedDateTime"
					  [label]="'task-action.planned-date' | translate"
					  [inputType]="inputTypeEnum.DateTime"
					  [placeholder]="''" />
		</div>

		<div>
			<edit-row (valueChanged)="updateUser($event)"
					  [model]="taskAction.assignedToUserId"
					  [displayValue]="!taskAction.assignedToUserId ? ('general.owner-placeholder' | translate) : ''"
					  [label]="'general.owner' | translate"
					  [inputType]="inputTypeEnum.Select"
					  [selectList]="usersList"
					  [placeholder]="'general.owner-placeholder' | translate"><user [userId]="taskAction.assignedToUserId" /></edit-row>
		</div>
		<div>
			<h3>{{ 'task-action.creator' | translate }}</h3>
			<user [userId]="taskAction.createdById" />
		</div>
	</section>
}
@else {
	<section>
		<h3>{{ 'task-action.details' | translate }}</h3>
		<div span-columns [formattedContent]="taskAction.details" [isHtmlContent]="true"></div>

		@if (taskAction.type == taskActionTypeEnum.inquiry) {
			<h3>{{ 'task-action.inquiry-reply' | translate }}</h3>
			<div span-columns>{{ inquiryModel.reply }}</div>
		}
		<div>
			<h3>{{ 'task-action.area' | translate }}</h3>
			<div>{{ taskAction.taskArea ? ('task-area.area-name.' + taskAction.taskArea.name | translate) : '' }}</div>
		</div>
		<div>
			<h3>{{ 'task-action.closed-by' | translate }}</h3>
			<user [userId]="taskAction.assignedToUserId" />
		</div>
		<div>
			<h3>{{ 'task-action.planned-date' | translate }}</h3>
			<div>{{ taskAction.plannedDate | customDate }}</div>
		</div>
		<div>
			<h3>{{ 'task-action.completed-date' | translate }}</h3>
			<div>{{ taskAction.completed | customDate }}</div>
		</div>
	</section>
}

<section>
	@if (!taskAction.completed) {
		<file-upload [label]="'task-action.file-upload' | translate"
						(busyChange)="uploading = $event"
						[uploadedFiles]="uploadedFiles"
						accept=".msg,.jpg,.pdf"
						[hideUploadedFiles]="true"
						[finalizeUrl]="uploadUrl" />
	}
	@if (taskAction.taskAttachments.length > 0) {
		<div>
			@for (attachment of taskAction.taskAttachments; track attachment) {
				<div><a (click)="downloadFile(attachment.fileReference)"><icon small type="file-signature" /> {{ attachment.fileReference?.fileName }}</a></div>
			}
		</div>
	}
</section>

@if (!taskAction.completed) {
	<section>
		<button #closeTaskActionButton [active]="canComplete()" [ignoreValidation]="true" (click)="closeTaskAction()">{{ 'task-action.complete' | translate }}</button>
	</section>
}
@if (showCreateCorrectionTaskActionButton()) {
	<section>
		<button #createCorrectionButton reject [ignoreValidation]="true" (click)="createCorrectionTaskAction()">{{ 'task-action.create-correction' | translate }}</button>
	</section>
}
@if (showCloneTaskflowAndCloseTaskActionButton()) {
	<section>
		<button reject [ignoreValidation]="true" (click)="cloneTaskflowAndCloseTaskAction()">{{ 'task-action.close-and-clone-taskflow' | translate }}</button>
	</section>
}
